<template>
    <div>
      <div class="container-fluid">
		  <form v-on:submit.prevent>
			  <div class="form-group row">
				  <label class="col-sm-3 col-form-label">
					  Vendor Name
					  <sup>*</sup>
				  </label>
				  <div class="col-sm-7 pr-5">
					  <input
						  type="text"
						  name="baseApiUrl"
						  v-model="vendor.temp_vendor"
						  class="form-control"
						  id="vc_alias"
						  placeholder="Vendor"
						  autocomplete = "off"
						  v-on:input = "addNewVendor"
					  >
					  <span
						  class = "no-data-style"
						  v-if = "isSubmitted && !vendor.temp_vendor">
						  Provide the required field
					  </span>
				  </div>

			  </div>
			  <div class="form-group row">
				  <label class="col-sm-3 col-form-label">
					  VC Alias
					  <sup>*</sup>
				  </label>
				  <div class="col-sm-7 pr-5">
					  <input
						  type="text"
						  name="baseApiUrl"
						  v-model="vendor.vc_alias"
						  class="form-control"
						  id="vc_alias"
						  placeholder="VC Alias"
						  autocomplete = "off"
						  v-on:input = "checkDuplicasy"
						  :disabled = "isDisableAlias"
					  >
				  </div>
			  </div>
			  <div class="form-group row">
				  <label class="col-sm-3 col-form-label">
					  Country
					  <sup>*</sup>
				  </label>
				  <div class="col-sm-7 pr-5">
					  <multiselect
						  v-model="vendor.country_currency"
						  :options="countryList"
						  label="country_name"
						  :searchable="true"
						  ref="multiselect"
						  track-by="country_name"
						  open-direction="bottom"
						  placeholder="Country"
						  class="form-control multi-dropdown select_filter"
						  selectLabel = ""
						  deselectLabel = ""
						  selectedLabel = ""
						  autocomplete="off"
						  style="max-height:40px;"
						  :multiple="false"
						  id="country_code"
						  :taggable="false"
					  />
					  <span
						  class = "no-data-style"
						  v-if = "isSubmitted && (!vendor.country_currency || !vendor.country_currency.country_code || vendor.country_currency.country_code == undefined || vendor.country_currency.country_code == '' )">
						  Provide the required field
					  </span>
					  <!-- <span
						class = "no-data-style"
						v-if = "seller && (!seller.country_code || seller.country_code == undefined || seller.country_code == '')  && isSubmitted">
						Provide the required field
					  </span> -->
				  </div>
			  </div>
			  <div class="form-group row">
				  <label class="col-sm-3 col-form-label">Account Type</label>
				  <div class="col-sm-7">
					  <div class="form-check d-inline-block">
						  <input
							  type="radio"
							  v-model="vendor.account_type"
							  value="Basic"
							  class="form-check-input mt-2"
							  id="exampleCheck1"
							  autocomplete = "off"
						  >
						  <label
							  class="form-check-label"
							  for="TargetingType1"
							  style="vertical-align: middle !important;"
						  >Basic</label>
					  </div>
					  <div class="form-check d-inline-block ml-3">
						  <input
							  type="radio"
							  v-model="vendor.account_type"
							  value="Premium"
							  class="form-check-input mt-2"
							  id="exampleCheck1"
							  autocomplete = "off"
						  >
						  <label
							  class="form-check-label"
							  for="TargetingType2"
							  style="vertical-align: middle !important;"
						  >Premium</label>
					  </div>
				  </div>
			  </div>
			  <div class="form-group row" style="height:40px">
				  <label class="col-sm-3 col-form-label"></label>
				  <div class="col-sm-7">
					  <p
						  class = "no-data-style"
						  v-if = "vendorAdded">
						  This vendor is already selected please choose another one
					  </p>
					  <p
						  class = "no-data-style"
						  v-if = "isVendorNamePresent">
						  This vendor is already present with this name please choose different name
					  </p>
					  <p
						  class = "no-data-style"
						  v-if = "isDataPresent">
						  This vendor is already present with this alias please choose different alias
					  </p>
					  
				  </div>
			  </div>
		  </form>
		</div>
	  </div>
  </template>

<script>

  import Multiselect from "vue-multiselect";
  import moment from "moment";
  import datePicker from 'vue-bootstrap-datetimepicker';

  export default {
  	name: "VendorData",
	components:{Multiselect, moment, datePicker},
	props:["vendor", "isDisableName", "isDisableAlias", "vendorList", "vendorAdded","index","countryList"],
	data(){
		return{
			client_added:true,
			isDataPresent:false,
			isVendorNamePresent:false,
			isSubmitted:false
		}
	},
	computed:{
		min_date(){
			return  moment().format("YYYY-MM-DD");
		},
	},
	watch:{
	},
	methods:{
		addNewVendor(val){

			if(val.currentTarget.value.trim().length){

				let data = val.currentTarget.value

				let obj = {
					vendor_name:data
				}
				// this.vendor.vc_alias = '';
				// this.vendor.account_type = '';
				// this.vendor.reporting_date = ''
				let existingName = this.vendorList.find(
					e=> e.vendor_name.toLowerCase().trim() == data.toLowerCase().trim()
				)
				if(existingName){
					this.isVendorNamePresent = true;
				}
				else{
					this.isVendorNamePresent = false;
				}
				this.vendor.vendor = obj
			}
			else{
				
				val.currentTarget.value = val.currentTarget.value.trim()
				this.vendor.temp_vendor = this.vendor.temp_vendor.trim()
			}

		},
		checkDuplicasy(val){

			if(val.currentTarget.value.trim().length){

				this.isDataPresent = false
				let existingData = this.vendorList.find((e) => this.vendor.vc_alias.toLowerCase().trim() == e.vc_alias.toLowerCase().trim())

				if(existingData){
					this.isDataPresent = true
				}
			}
			else{
				val.currentTarget.value = val.currentTarget.value.trim()
				this.vendor.vc_alias = this.vendor.vc_alias.trim()
			}

		},
		selectNewVendor(data){
			let obj = {}

			obj.go_vendor_cd = data.id;
			obj.vendor_name = data.vendor_name;
			obj.vc_alias = data.vc_alias;
			obj.account_type = data.account_type;
		//	obj.reporting_date = data.reporting_startdate ? moment(data.reporting_startdate).utc().format("YYYY-MM-DD"): '';
			obj.vendor = {vendor_name:data.vendor_name, id:data.id} ;

			this.$emit("updateVendorObj", obj)

			this.isDataPresent = true
		},
		removeVendor(){
			this.vendor = {}
			this.vendorAdded = false;
			this.isDataPresent = false;
			this.isVendorNamePresent = false;
		},
		validateData(data){
			this.isSubmitted = data
		}

	},
	beforeDestroy () {

	},
}
</script>
